module.exports = __webpack_public_path__ + "img/nav_weather.776da7fa.svg";